module.exports = __webpack_public_path__ + "b3ce5b7036286816852d93c26bb49b15.pdf";